import styled from 'styled-components';

export const UploadLabel = styled.label`
  height: 32px;
  width: 260px;
  border: 1px solid ${(props) => props.theme.colors['primary-60']};
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  color: ${(props) => props.theme.colors['primary-60']};
  transition: background-color 0.3s ease;

  input {
    display: none;
  }

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors['secondary-20']};
  }
`;

export const FileName = styled.a`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  display: block;
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileUploadedRow = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export const Video = styled.video`
  width: 100%;
  max-height: 50vh;
  background-color: black;
`;
